export default "__VITE_ASSET__CQc3HvSr__"